import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "photoList" }
const _hoisted_2 = { class: "toc_ui__photoList_Box" }
const _hoisted_3 = { class: "toc_ui__photoList_title" }
const _hoisted_4 = {
  key: 0,
  class: "toc_ui__photoList_PhotoList"
}
const _hoisted_5 = {
  key: 0,
  class: "toc_ui__photoList_item_img_wrapper"
}
const _hoisted_6 = {
  key: 0,
  class: "video-play-icon"
}
const _hoisted_7 = { class: "toc_ui__photoList_item_text" }
const _hoisted_8 = { class: "toc_photoListAll" }
const _hoisted_9 = {
  key: 0,
  class: "video-player-overlay"
}
const _hoisted_10 = {
  key: 0,
  class: "video-loading-tip"
}
const _hoisted_11 = {
  key: 1,
  class: "video-error-tip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pageTitle = _resolveComponent("pageTitle")
  const _component_van_tab = _resolveComponent("van-tab")
  const _component_van_tabs = _resolveComponent("van-tabs")
  const _component_photoListAll = _resolveComponent("photoListAll")
  const _component_DetectPlayer = _resolveComponent("DetectPlayer")

  return (_openBlock(), _createBlock("div", {
    class: ["toc_ui__photoList_main", {'isAll':_ctx.state.isAll}],
    style: {minHeight:_ctx.state.clientHeight + 'px'}
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_pageTitle, {
        isBigImg: _ctx.state.isShowSwiper,
        backFun: _ctx.state.backFun,
        onHiddenSwiperByTitle: _ctx.hiddenSwiperByTitle
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode("span", {
            class: "toc_ui__pageTitle_right",
            onClick: _cache[1] || (_cache[1] = () => {_ctx.state.isShowSwiper = false;_ctx.state.noImg=0})
          }, "全部", 512), [
            [_vShow, _ctx.state.isShowSwiper]
          ])
        ]),
        _: 1
      }, 8, ["isBigImg", "backFun", "onHiddenSwiperByTitle"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_van_tabs, {
            modelValue: _ctx.state.photoTab,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.photoTab = $event)),
            sticky: "",
            swipeable: "",
            ellipsis: false,
            "line-width": "100",
            onChange: _ctx.changePhotoType,
            ref: "photoTabs"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.listTab, (item) => {
                return (_openBlock(), _createBlock(_component_van_tab, {
                  key: item.id,
                  name: item.id,
                  title: `${item.name}(${item.num})`
                }, {
                  default: _withCtx(() => [
                    (!_ctx.state.isShowSwiper)
                      ? (_openBlock(), _createBlock("div", _hoisted_4, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.photoList, (photo, idx) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "toc_ui__photoList_item",
                              key: photo.photoIdStr || photo.videoCode || idx
                            }, [
                              (!_ctx.state.noImg)
                                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                                    _createVNode("div", {
                                      class: "toc_ui__photoList_item_img",
                                      onClick: ($event: any) => (_ctx.handleItemClick(photo))
                                    }, [
                                      _createVNode("img", {
                                        src: _ctx.getImgUrl(photo)
                                      }, null, 8, ["src"]),
                                      (photo.videoCode)
                                        ? (_openBlock(), _createBlock("div", _hoisted_6))
                                        : _createCommentVNode("", true)
                                    ], 8, ["onClick"]),
                                    _createVNode("div", _hoisted_7, [
                                      _createVNode("span", null, _toDisplayString(_ctx.getVideoName(photo) || photo.photoName), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["name", "title"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"]),
          _withDirectives(_createVNode("div", _hoisted_8, [
            _createVNode(_component_photoListAll, {
              imgListLen: _ctx.state.imgListLen,
              onAllPhont: _ctx.allPhont,
              tabName: _ctx.state.actTab,
              initialSlide: _ctx.state.initialSlide,
              noImg: _ctx.state.noImg,
              swiperPhotoList: _ctx.state.swiperPhotoList,
              onHiddenSwiperByTitle: _ctx.hiddenSwiperByTitle,
              onSlideChange: _ctx.changeTab
            }, null, 8, ["imgListLen", "onAllPhont", "tabName", "initialSlide", "noImg", "swiperPhotoList", "onHiddenSwiperByTitle", "onSlideChange"])
          ], 512), [
            [_vShow, _ctx.state.isShowSwiper]
          ])
        ])
      ])
    ]),
    (_ctx.isShowVideoPlayer)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode("div", {
            class: "video-close-btn",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeVideoPlayer && _ctx.closeVideoPlayer(...args)))
          }, "✕"),
          (_ctx.videoLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_10, "加载中..."))
            : _createCommentVNode("", true),
          (_ctx.videoError)
            ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(_ctx.videoError), 1))
            : _createCommentVNode("", true),
          (_ctx.isShowVideoPlayer)
            ? (_openBlock(), _createBlock(_component_DetectPlayer, {
                key: _ctx.selectedVideo ? _ctx.selectedVideo.videoId : 'empty',
                vid: "video_player_overlay",
                ref: "videoPlayer",
                class: "video-player-container",
                "play-data": _ctx.videoPlayData
              }, null, 8, ["play-data"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 6))
}